import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { SvgWhatsapp } from "../../../utils/svgIcons";

const NewShare = ({ singlePackageData }) => {
  const [message, setMessage] = useState(
    singlePackageData?.packageHandle +
      "click below to check detailed itinerary:👇👇👇"
  );
  const [emailData, setEmailData] = useState([]);
  const [markupValue, setMarkupValue] = useState([]);
  const [selectedOption, setSelectedOption] = useState("whatsapp");
  const [selectedOptionNew, setSelectedOptionNew] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const userType = localStorage.getItem("userType");

  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const handleDownload = () => {};

  const handleDownloadHandler = () => {};

  const [showPopup, setShowPopup] = useState(false);
  const [email, setEmail] = useState("");
  const [url, setUrl] = useState(
    `https://www.mountainmysteries.com/package/${singlePackageData?.packageHandle}?location=&guest=2&children=0&packagehandle=${singlePackageData?.packageHandle}`
  );

  useEffect(() => {
    setMessage(
      singlePackageData?.packageHandle +
        " " +
        "click below to check detailed itinerary:👇👇👇"
    );
    setUrl(
      `https://www.mountainmysteries.com/package/${singlePackageData?.packageHandle}?location=&guest=2&children=0&packagehandle=${singlePackageData?.packageHandle}`
    );
  }, [singlePackageData]);

  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodedMessage}%0A${encodeURIComponent(
      url
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const handlePrintClick = (printId, ignoreIds) => {
    ignoreIds?.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        element.classList.add("no-print");
      }
    });
    const printContent = document.getElementById(printId).innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    ignoreIds.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        element.classList.remove("no-print");
      }
    });
  };

  const sendEmailData = (e) => {
    if (e) {
      e.preventDefault();
    }

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);

    const raw = JSON.stringify({
      email: emailData,
      package_id: singlePackageData?.packageId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/send-package-detail`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result?.success) {
          setShowPopup(false);
          toast.success(result?.message);
          setEmail("");
        } else {
          toast.error(result?.message);
        }
      })
      .catch((error) => toast.error("Something went wrong"));
  };

  const sendEmailDataHandler = () => {
    if (emailData === "") {
      toast.error("Please enter email");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailData)) {
      toast.error("Please enter a valid email");
      return;
    }
    sendEmailData();
  };
  return (
    <>
      <div
        // onClick={handleClick}
        onClick={() => setShowPopup(true)}
        className="cursor_pointer flex align_items_center flex_direction_col"
      >
        <span>
          <SvgWhatsapp color="#009A50" />
        </span>
        <span className="color_333">Share</span>
      </div>

      {showPopup && (
        <div className="select_hotel_popup_overlay">
          <div className="select_hotel_popup_overlay_content">
            <h4>Share On</h4>
            <label style={{ marginBottom: "8px " }}>
              <input
                type="radio"
                name="whatsapp"
                value="whatsapp"
                checked={selectedOption === "whatsapp"}
                onChange={() => handleOptionChange("whatsapp")}
              />
              Whatsapp
            </label>
            {/* <label>
              <input
                type="radio"
                name="email"
                value="email"
                checked={selectedOption === "email"}
                onChange={() => handleOptionChange("email")}
              />
              Email
            </label> */}

            {selectedOption === "email" && (
              <div style={{ margin: "10px 0", width: "100%" }}>
                <input
                  placeholder="Enter Email"
                  style={{ width: "100%" }}
                  type="input"
                  name="email"
                  value={emailData}
                  onChange={(e) => setEmailData(e.target.value)}
                  className="w-full"
                />
              </div>
            )}

            {/* {userType === "agent" && isLoggedIn  && (
              <div style={{ margin: "15px 0 10px 0", width: "100%" }}>
                <h4>Add Additional Markup</h4>

                <label style={{ marginBottom: "8px " }}>
                  <input
                    type="radio"
                    name="selected"
                    value="selected"
                    checked={selectedOptionNew === "selected"}
                    onChange={() => setSelectedOptionNew("selected")}
                  />
                  Keep Selected Markup
                </label>
                <label style={{ marginBottom: "8px " }}>
                  <input
                    type="radio"
                    name="new"
                    value="new"
                    checked={selectedOptionNew === "new"}
                    onChange={() => setSelectedOptionNew("new")}
                  />
                  Add New Markup
                </label>

                {selectedOptionNew === "new" && (
                  <div style={{ margin: "10px 0", width: "100%" }}>
                    <input
                      placeholder="Enter markup value in Percentage"
                      style={{ width: "100%" }}
                      type="input"
                      name="markupValue"
                      value={markupValue}
                      onChange={(e) => setMarkupValue(e.target.value)}
                    />
                  </div>
                )}
              </div>
            )} */}

            <div className="flex flex_gap_10 mt-10">
              <button
                // onClick={isLoggedIn ? handleDownload : handleDownloadHandler}
                onClick={
                  selectedOption === "email"
                    ? sendEmailDataHandler
                    : handleClick
                }
                className="select_hotel_common_btn w-half"
              >
                Share
              </button>
              <button
                onClick={() => setShowPopup(false)}
                className="select_hotel_cancel_btn w-half"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewShare;
